import React from 'react';
import classNames from 'classnames';
import './DealGroupColorSwatch.scss';

interface DealGroupColorSwatchProps {
    hexColor?: string | null;
    size?: 'sm' | 'md';
    selected?: boolean;
    className?: string;
}

const DealGroupColorSwatch: React.FC<DealGroupColorSwatchProps> = ({
    hexColor, size = 'md', selected = false, className,
}) => {
    return (
        <span
            className={classNames(
                `DealGroupColorSwatch--${size} rounded-circle`,
                {
                    'DealGroupColorSwatch--empty': !hexColor,
                    'DealGroupColorSwatch--selected': selected,
                },
                className,
            )}
            style={hexColor ? { backgroundColor: hexColor } : undefined}
        />
    );
};

export default DealGroupColorSwatch;
